import DataStore from "../../../../core/stores/dataStore.js";

module.exports = function (componentId, widgetId, legends, togglePreloader) {

  var changeCallback = null;
  var currentValue = null;
  var shouldUpdate = false;
  var legends = legends;
  var timeout;

  this.id = componentId;
  this.widgetId = widgetId;

  togglePreloader(true);

  this.addChangeListener = function (callback) {
    changeCallback = callback;
  };

  this.update = function (updatingDatasetId, valueFromHistoricData, forceUpdate) {
    const newValue = valueFromHistoricData !== undefined ?
      valueFromHistoricData : this.prepareData();
    if (newValue != null && newValue !== currentValue) {
      if (newValue == "null") {
        return true;
      }
      currentValue = newValue;
      shouldUpdate = true;
    }

    if (forceUpdate) {
      shouldUpdate = true;
    }
  };

  this.loadHistoricData = function (historicData) {
    togglePreloader(false);
    var value = this.prepareData(historicData);
    if (typeof value === "string" || (!isNaN(value) && value != null)) {
      this.update(null, value);
      changeCallback(currentValue);
    }
  };

  /***
   * Evaluates the legend expression using the generated function.
   * It uses snapshotData for the initial loading and the server side functions.
   * For realtime update, it uses cached data from the data store.
   *
   * @param snapshotData
   * { "dataset1" : [...], "dataset2: [...], ... }
   *
   * @returns value evaluated value
   */
  this.prepareData = function (snapshotData) {
    for (let prop in snapshotData) {
      if (Array.isArray(snapshotData[prop])) {
        snapshotData[prop] = snapshotData[prop].filter(d => d !== null);
      }
    }
    const datasetsData = {};
    const legend = legends[0];
    if (legend.hasOwnProperty("serverSideFunction") && legend.serverSideFunction.length > 0 && snapshotData) {

      // migration code for the old structure
      if (!Array.isArray(legend.serverSideFunction)) {
        legend.serverSideFunction = [legend.serverSideFunction];
      }

      legend.serverSideFunction.map(ssf => {
        const requestId = ssf.requestId;
        datasetsData[requestId] = snapshotData[requestId][0];
        if (datasetsData[requestId]) {
          datasetsData.time = datasetsData[requestId].epochSecond;
        }
      });
    } else {
      for (let key in legends[0].mappings) {
        const datasetId = legends[0].mappings[key].datasetId;
        datasetsData[datasetId] = snapshotData ?
          snapshotData[datasetId][0] :
          DataStore.get(datasetId);
      }
    }

    let value = null;
    try {
      value = legends[0].functions.y(datasetsData);
    } catch (e) {
    }

    return value;
  };

  this.getHistorySize = function () {
    return 1;
  };

  this.onLegendsModified = function () {
  };

  this.isNotInterestedInAnyDataFields = function () {
    return false;
  };

  this.destroy = function () {
    clearTimeout(timeout);
  };

  function startDelayedUpdate() {
    timeout = setTimeout(function () {
      if (changeCallback !== null && shouldUpdate) {
        changeCallback(currentValue);
        shouldUpdate = false;
      }
      startDelayedUpdate();
    }, 1000);
  }


  this.getLegends = function () {
    return legends;
  };

  this.doesNotHaveAnyLegends = function () {
    return false;
  };

  startDelayedUpdate();


};


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/controller.js